/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import CloseAction from './CloseAction/index'
import IntraoralMobileCapture from './IntraoralMobileCapture/index'
import React from 'react'
import Request from './Request/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CaptureImageRequest/Content/Content"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Capture using mobile device"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Request
  viewPath={`${viewPath}/Request`}
/>
<IntraoralMobileCapture
  viewPath={`${viewPath}/IntraoralMobileCapture`}
/>
{children}
</React.Fragment>)
}